import React, { useMemo } from 'react';
import { pick } from 'ramda';

import { AboveHeader } from '@core/js/components/main/AboveHeader';
import { Header } from '@core/js/components/main/Header';
import { Menu } from '@core/js/components/main/Menu';
import { Reconnect } from '@core/js/components/main/Reconnect';
import { SignInNotificationBanner } from '@core/js/components/main/SignInNotificationBanner';
import { SlideMenu } from '@core/js/components/main/SlideMenu';
import { WebContent } from '@core/js/components/system/WebContent';

import { CookiesRegulationMessage } from '@interlayer/js/components/main/CookiesRegulationMessage/CookiesRegulationMessage';
import { Footer } from '@interlayer/js/components/main/Footer/Footer';
import { MyAccountSidebar } from '@interlayer/js/components/main/MyAccountSidebar';
import { PageRouter } from '@interlayer/js/components/system/Router/components/PageRouter/PageRouter';
import { FloatingButtons } from '@interlayer/js/custom/components/main/FloatingButtons';
import { StickyBottomContainer } from './sun/components/StickyBottomWrapper';

import { BACKBONE_APP_ROOT } from '@core/js/backbone/constants';
import { useUpdateHeaderHeight } from '@core/js/components/system/App/hooks';
import { LAYER_POSITION } from '@core/js/components/system/Router/constants.ts';
import { useAppSelector } from '@core/js/store/hooks';

import style from '@core/js/components/system/Router/components/AppRouter/AppRouter.scss';

/**
 * Application Router that is aware about business logic.
 */
// Sun: added isAdminLoggedIn class and added StickyBottomContainer, FloatingButtons
// TODO: move isAdminLoggedIn to global tag for all applications
export const AppRouter = () => {
    const {
        applicationWCID,
        headerHeight,
        cookiesConfiguration: { layerPosition },
        isAdminLoggedIn
    } = useAppSelector(pick(['applicationWCID', 'headerHeight', 'cookiesConfiguration', 'isAdminLoggedIn']));
    const headerRef = useUpdateHeaderHeight();
    const contentInlineCss = useMemo(() => ({
        paddingTop: `${headerHeight}px`,
        '--scroll-margin-top': `${headerHeight}px`
    }), [headerHeight]);

    if (applicationWCID) {
        return <WebContent id={applicationWCID} />;
    }

    return (
        <>
            <SlideMenu />
            <MyAccountSidebar />
            <div
                className={`${style.header} header ${isAdminLoggedIn ? 'isAdmin' : ''}`}
                ref={headerRef}
            >
                <SignInNotificationBanner />
                {layerPosition === LAYER_POSITION.TOP && <CookiesRegulationMessage />}
                <AboveHeader />
                <div className={BACKBONE_APP_ROOT}>
                    <div className="fn-navigation-container navigation-container">
                        <Header />
                        <Menu />
                    </div>
                </div>
            </div>
            <div
                className={style.content}
                style={contentInlineCss}
            >
                <Reconnect />
                <PageRouter />
            </div>
            <Footer />
            <FloatingButtons />
            <StickyBottomContainer layerPosition={layerPosition} />
        </>
    );
};
